
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import { useEventListener } from '@vueuse/core'
import { WeveButtonIcon } from '@weve/ui'

import { Pagination } from '@/types'
import { ChevronRightIcon, ChevronLeftIcon } from '@icons'

export default defineComponent({
  name: 'DialogPagination',
  components: {
    WeveButtonIcon,
    ChevronRightIcon,
    ChevronLeftIcon,
  },
  props: {
    pagination: {
      type: Object as PropType<Pagination>,
      required: true,
    },
  },
  emits: {
    prev: null,
    next: null,
  },
  setup(_, { emit }) {
    function prev() {
      emit('prev')
    }
    function next() {
      emit('next')
    }
    function onKeyUp(e: KeyboardEvent) {
      if (e.target instanceof HTMLElement) {
        const { tagName } = e.target
        if (
          tagName === 'INPUT' ||
          tagName === 'TEXTAREA' ||
          e.target.isContentEditable
        ) {
          return
        }
      }

      if (e.key === 'ArrowRight') {
        next()
        return
      }

      if (e.key === 'ArrowLeft') {
        prev()
      }
    }
    useEventListener('keyup', onKeyUp)
    return { prev, next, onKeyUp }
  },
})
